import {
  Box,
  Button,
  ButtonGroup,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid as Grid,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { Cancel, Check, CloudUpload } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import useDisclosure from "../../hooks/ui/useDisclosure";
import ImageDialog from "../ImageDialog";
import { LoadingButton } from "@mui/lab";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default function PhotoEditDialog({
  title,
  currentImage,
  onSubmit,
  ...disclosureProps
}) {
  const [image, setImage] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [savingInProgress, setSavingInProgress] = useState(false);
  const viewImageDisclosure = useDisclosure();

  // Handle file selection and create a preview URL
  const handleFileUpload = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      setSelectedFile(file);
      setPreviewImage(URL.createObjectURL(file));
      setImage(file);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSavingInProgress(true);
    await onSubmit(image);
    setSavingInProgress(false);
  };

  return (
    <Dialog {...disclosureProps}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Grid
          container
          sx={{ width: "100%" }}
          spacing={2}
          component={"form"}
          onSubmit={handleSubmit}
        >
          <Grid size={12}>
            <Box display="flex" flexDirection="column" gap={2}>
              <Button
                component="label"
                variant="contained"
                startIcon={<CloudUpload />}
              >
                {selectedFile || currentImage ? "Change Photo" : "Upload Photo"}
                <VisuallyHiddenInput
                  type="file"
                  accept="image/*"
                  onChange={handleFileUpload}
                />
              </Button>

              <Typography variant="body2" component={"div"}>
                {selectedFile
                  ? `Selected file: ${selectedFile.name}`
                  : currentImage
                  ? "Photo already uploaded"
                  : "No photo uploaded yet"}

                <Chip
                  sx={{ ml: 1 }}
                  label="View Image"
                  onClick={viewImageDisclosure.onOpen}
                  disabled={!(previewImage || currentImage)}
                  size="small"
                />
              </Typography>
            </Box>
            <Divider sx={{ my: 2 }} />
            <ButtonGroup fullWidth>
              <LoadingButton
                type="submit"
                startIcon={<Check />}
                loading={savingInProgress}
                disabled={!image}
              >
                Save
              </LoadingButton>
              <Button startIcon={<Cancel />} disabled={savingInProgress}>
                Cancel
              </Button>
            </ButtonGroup>
          </Grid>
          <ImageDialog
            src={previewImage || currentImage}
            {...viewImageDisclosure.getDisclosureProps()}
          />
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
